export const messages = {
  appTitle: 'RAE',
  appLogoTitle: 'Reitti- ja aikataulueditori',
  traffic: 'Liikennetilanne',
  feedback: 'Palauteväylä',
  train: 'Junalähdöt',
  digitraffic: 'Digitraffic',
  digitransit: 'Digitransit',
  nap: 'NAP',
  contact: 'Yhteystiedot',
  contactLink: 'yhteystiedot',
  privacy: 'Tietosuojaseloste',
  accessibility: 'Saavutettavuus',
  rae: 'RAE - Reitti- ja aikataulueditori',
  about: 'Tietoja palvelusta',
  instructions: 'RAE-ohjeet ja -tiedotteet',
  terms: 'Käyttöehdot',
  support: 'Tuki',
  channels: 'Tukikanavat',
  login: 'Kirjaudu',
  logout: 'Kirjaudu ulos',
  register: 'Rekisteröidy',
  redirecting: 'Ohjataan uudelleen...',
  loginIntro: 'Aloita palvelun käyttö kirjautumalla sisään.',
  registerIntro: 'Luo tili, jos olet uusi käyttäjä.',
  localeen: 'In English',
  localefi: 'Suomeksi',
  localesv: 'På Svenska',
  shortcuts: 'Pikavalinnat',
  fintrafficApp: 'Fintraffic Mobiili',
  fintrafficAppLink: 'digitaalisetpalvelut/mobiili',
  fintrafficMatka: 'Fintraffic Matka',
  fintrafficSky: 'Fintraffic Sky',
  landingPageIntroP1:
    'Reitti- ja aikataulueditori (RAE) on Fintraffic Oy:n hallinnoima editori, jolla voidaan digitoida ja tallentaa joukkoliikennereittejä ja kutsujoukkoliikennettä pysäkkiketjuineen ja pysäkkikohtaisine aikatauluineen NeTEx-muotoiseksi matkatietoaineistoksi.',
  landingPageIntroP2:
    'RAE-työkalussa julkaistut reitit muodostavat operaattorikohtaisen matkatietoaineiston, jonka voitte ilmoittaa osana matkatietorajapintojanne kansalliseen yhteyspisteeseen {link} osana muita tietojanne. Finapiin ilmoitettu aineisto lisätään automaattisesti valtakunnalliseen Koontipalveluun ja sitä kautta reittioppaille. Lisää aineiston toimittamisesta Finapiin löydät ohjesivustolta.',
  landingPageIntroP3:
    'RAE on niin sanottu olennaisten tietojen peruseditori, joka on tarkoitettu toimijoille, joiden reitti- ja vuoromäärätarjonta ei ole suuri (esim. 1-20 ylläpidettävää reittiä). Työkalun avulla on mahdollista mallintaa reittiliikenteen lisäksi kutsujoukkoliikennettä.',
};
